'use strict';

const WishlistButton = {
  toggleWishlistButtonStyle() {
    this.$wishlistButton.toggleClass('wishlisted');
    this.$wishlistButtonTextAdd.toggleClass('hidden');
    this.$wishlistButtonTextRemove.toggleClass('hidden');
  },

  onAddItemSuccess(response) {
    const addedItem = {
      dealId: this.data.dealUUID,
      itemId: response.itemId,
      listId: response.listId,
      optionId: this.data.selectedOptionUUID,
      removeItemUrl: `/deals/wishlists_proxy/remove/${response.listId}/${
        response.itemId
      }`,
    };

    this.data.items.push(addedItem);
    this.data.removeItemUrl = addedItem.removeItemUrl;
    this.toggleWishlistButtonStyle();
  },

  addItemToWishlist() {
    this.$wishlistButton.prop('disabled', true);
    return $.ajax({
      url: this.data.addItemUrl,
      dataType: 'json',
      type: 'POST',
      data: {
        dealId: this.data.dealUUID,
        optionId: this.data.selectedOptionUUID || undefined,
        _csrf: this.data.csrf,
      },
      error() {
        $('.wishlist-add-error')
          .fadeIn()
          .delay(3000)
          .fadeOut();
      },
      success: data => {
        this.onAddItemSuccess(data);
      },
      complete: () => {
        this.$wishlistButton.prop('disabled', false);
      },
    });
  },

  removeItemFromWishlist() {
    this.$wishlistButton.prop('disabled', true);
    return $.ajax({
      url: this.data.removeItemUrl,
      dataType: 'json',
      type: 'POST',
      data: {
        _csrf: this.data.csrf,
      },
      error() {
        $('.wishlist-remove-error')
          .fadeIn()
          .delay(3000)
          .fadeOut();
      },
      success: () => {
        this.toggleWishlistButtonStyle();
        this.data.items = this.data.items.filter(
          ({ optionId }) => optionId !== this.data.selectedOptionUUID
        );
      },

      complete: () => {
        this.$wishlistButton.prop('disabled', false);
        this.data.selectedOptionUUID = null;
      },
    });
  },

  wishlistButtonClicked() {
    if (this.$wishlistButton.hasClass('wishlisted')) {
      return this.removeItemFromWishlist();
    } else {
      return this.addItemToWishlist();
    }
  },

  multiOptionBreakoutClicked(event) {
    const target = $(event.target);
    this.data.selectedOptionUUID = target.data('uuid');
    return this.updateWishlistedNotifier();
  },

  updateWishlistedNotifier() {
    this.$wishlistButton.removeClass('wishlisted');
    this.$wishlistButtonTextAdd.removeClass('hidden');
    this.$wishlistButtonTextRemove.addClass('hidden');

    const currentItem = this.data.items.find(
      ({ optionId }) => optionId === this.data.selectedOptionUUID
    );

    if (currentItem) {
      this.$wishlistButton.addClass('wishlisted');
      this.$wishlistButtonTextAdd.addClass('hidden');
      this.$wishlistButtonTextRemove.removeClass('hidden');
      this.data.removeItemUrl = currentItem.removeItemUrl;
    }

    return currentItem;
  },

  listenToOptionSelection() {
    window.DealEventPipe.on(
      'priceUpdate',
      ({ variationsSelected, uuid } = {}) => {
        const $tooltip = $('#select-option-tooltip');
        if (window.GIG && window.GIG.Tooltip) {
          window.GIG.Tooltip.close($tooltip);
        }
        this.data.selectedOptionUUID = variationsSelected ? uuid : null;
        return this.updateWishlistedNotifier();
      }
    );
  },

  init({ csrf, wishlist }, done) {
    this.$wishlistButton = $('.add-to-wishlist-btn');
    this.$wishlistButtonTextAdd = $('.add-to-wishlist-btn-text-add');
    this.$wishlistButtonTextRemove = $('.add-to-wishlist-btn-text-remove');
    this.data = wishlist;
    this.data.csrf = csrf;
    this.data.selectedOptionUUID = this.data.selectedOptionUUID || null;

    this.listenToOptionSelection();

    this.$wishlistButton.on('click', this.wishlistButtonClicked.bind(this));

    $('.multi-option-breakout input,.multi-option-overlay-list input').on(
      'click',
      this.multiOptionBreakoutClicked.bind(this)
    );

    return done();
  },
};

module.exports = WishlistButton;
